import React from "react";
import { graphql, StaticQuery } from "gatsby";
import PropTypes from "prop-types";

const Author = props => {
  const { id, theme } = props;

  return (
    <StaticQuery
      query={graphql`
        query AuthorQuery {
          authors: allMarkdownRemark(
            limit: 1000
            sort: { fields: [fields___prefix], order: DESC }
            filter: { frontmatter: { identifier: { ne: null } } }
          ) {
            edges {
              node {
                fields {
                  slug
                }
                frontmatter {
                  bio
                  identifier
                  name
                  avatar {
                    childImageSharp {
                      desktop: fluid(maxWidth: 300, maxHeight: 300, quality: 90, cropFocus: CENTER) {
                        src
                        srcWebp
                      }
                      tablet: fluid(maxWidth: 150, maxHeight: 150, quality: 90, cropFocus: CENTER) {
                        src
                        srcWebp
                      }
                      thumb: fluid(maxWidth: 100, maxHeight: 100, quality: 100, cropFocus: CENTER) {
                        src
                        srcWebp
                      }
                      mobile: fluid(maxWidth: 50, maxHeight: 50, quality: 90, cropFocus: CENTER) {
                        src
                        srcWebp
                      }
                    }
                  }
                }
              }
            }
          }
        }
      `}
      render={data => {
        const {
          authors: { edges: authorsRes }
        } = data;

        // Find matching author
        const authorObj = authorsRes.find(author => author.node.frontmatter.identifier === id);

        const authorName = authorObj.node.frontmatter.name;
        const authorBio = authorObj.node.frontmatter.bio;
        const authorSlug = authorObj.node.fields.slug;
        const authorAvatar = authorObj.node.frontmatter.avatar.childImageSharp.thumb;

        return (
          <React.Fragment>
            <section className="authorprofile">
              <div className="wrapper">
                <div className="info">
                  <a href="/about" className="profile gravatar">
                    <picture>
                      <source srcset={authorAvatar.srcWebp} type="image/webp"/>
                      <source srcset={authorAvatar.src} type="image/jpeg"/>
                      <img src={authorAvatar.src} alt={authorName} />
                    </picture>
                  </a>
                  <div className="meta">
                    <span className="title">Author</span>
                    <h3>
                      <a href="/about">{authorName}</a>
                    </h3>
                  </div>
                </div>
                <p className="bio">{authorBio}</p>
              </div>
            </section>

            {/* --- STYLES --- */}
            {/*language=SCSS*/}
            <style jsx>{`
              .wrapper {
                max-width: 700px;
                width: 90%;
                margin: 0 auto;
              }

              .authorprofile,
              .authortitle {
                padding: 35px 0 0;
                margin: 0;
                background: #f9f9f9;
                border-top: 1px solid #f3f3f3;
                text-align: center;

                .info {
                  margin: -73px 0 30px;
                }

                .gravatar img {
                  width: 80px;
                  height: 80px;
                  border-radius: 90px;
                  overflow: hidden;
                }

                .meta {
                  margin-top: 40px;
                }

                .meta .title,
                .meta .twittertag {
                  font-family: ${theme.font.reidweb.subheader};
                  font-weight: 400;
                  font-size: 15px;
                  line-height: normal;
                  text-transform: uppercase;
                  color: #c9c9c9;
                }

                .meta .title {
                  display: block;
                  margin-top: 26px;
                }

                .meta .twittertag {
                  color: #c9c9c9;
                  font-size: 14px;
                  text-transform: none;

                  &:hover {
                    color: #959595;
                  }
                }

                .meta h3 {
                  margin: 5px 0 6px;
                }

                .meta h3 a {
                  font-family: ${theme.font.reidweb.header};
                  font-weight: 600;
                  font-size: 24px;
                  line-height: normal;
                  color: #403f3f;
                }

                p {
                  font-family: ${theme.font.reidweb.main};
                  font-weight: 400;
                  font-size: 17px;
                  line-height: 32px;
                  margin: 20px 0 65px;
                  color: #62646c;
                }

                .authorsocial {
                  overflow: hidden;
                  display: inline-block;
                  margin-bottom: 40px;
                  text-align: center;
                  padding: 0;

                  li {
                    display: inline-block;
                    margin-right: 8px;
                    margin-bottom: 10px;

                    &:last-child {
                      margin-right: 0;
                    }

                    a {
                      font-size: 12px;
                      line-height: 26px;
                    }

                    a:hover {
                      color: #fff;
                    }
                  }
                }
                :after {
                  display: block;
                  clear: both;
                  content: "";
                  width: 20%;
                  background: #ececec;
                  height: 1px;
                  margin-top: 35px;
                }
              }

              @from-width tablet {
                .author {
                  display: flex;
                }
                .avatar {
                  flex: 0 0 auto;
                }
              }
            `}</style>
          </React.Fragment>
        );
      }}
    />
  );
};

Author.propTypes = {
  id: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired
};

export default Author;
